/**
 * Flyer designs — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_office_formats`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const flyerDesignsPack: ToilePack = {
    slug: 'flyer-designs',
    category: 'office',
    name: 'Flyer designs',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'sale', label: 'Sale', subject: 'a sale flyer with "SALE" in large letters and price placeholders'},
        {key: 'event', label: 'Event', subject: 'an event flyer with date and venue lines'},
        {key: 'service', label: 'Service', subject: 'a service flyer with icons'},
    ],
    styles: [
        {key: 'bold', label: 'Bold', style: 'bold poster-style flyer with a huge headline, heavy colour blocks and a bright call-to-action button shape', palette: 'red, yellow and black', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
        {key: 'clean', label: 'Clean', style: 'clean modern flyer with a white background, one large colour shape and neat icon circles', palette: 'teal and white', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
        {key: 'gradient', label: 'Gradient', style: 'stylish flyer with a smooth colour gradient background and rounded white content cards', palette: 'purple to pink gradient with white cards', framing: 'single page seen straight on, centered on a plain light grey ground with an even white margin around the sheet'},
    ],
    directions: ['night theme', 'red theme', 'pastel'],
    directionHint: 'try: night theme',
    seo: {
        title: 'Flyer design: sale, event, service',
        metaDescription: 'Nine printable flyer designs: a sale, an event and a service flyer, each in bold, clean or gradient style.',
        h1: 'Flyer design: sale, event, service',
        tagline: 'Three flyers, each in three styles, with a bold layout and empty spaces for your details.',
        intro: 'A flyer design is a one-page sheet that announces a sale, an event or a service. These nine show a sale flyer with placeholders for the offer; an event flyer with date and venue lines; and a service flyer with icons. Only the Call Now and Date labels are lettered. Type a twist, such as pastel, and it is a request.',
        useCases: [
            'a sale notice for a shop window',
            'an invitation to a local event',
            'an ad for a home service such as repairs or tutoring',
            'a leaflet to pin on a noticeboard',
        ],
        faq: [
            {q: 'Are the offer details filled in?', a: 'No. The offer details are placeholders. Put your own figures in.'},
            {q: 'Can I use it for an event with a date?', a: 'Yes. The event flyer has date and venue lines to fill in.'},
            {q: 'How do the three styles differ?', a: 'Bold uses heavy colour blocks and a large headline area. Clean is white with one large teal shape. Gradient uses a purple to pink background with white cards.'},
            {q: 'Is the page ready to print?', a: 'It is a flat, print-ready page with an even margin, so it can be printed at full size.'},
        ],
    },
}
